module.exports = __webpack_public_path__ + "img/notreEquipe.6f90eec2.jpeg";